<template>
	<ViewWrapper :carregando="loading">
		<template #titulo>
			Solicitação #{{ dataVaga ? dataVaga.protocolo : "" }}
		</template>
		<template #botaoHeader>
			<v-row v-if="rotaAdmin" justify="center">
				<v-col cols="12" class="align-content-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="GERAR PDF"
							@click="gerarPDF"
						/>
				</v-col>
			</v-row>
			<v-row v-if="dataVaga && route.fullPath.includes('/visualizar') && permissaoAcao.reaproveitar.includes(dataVaga.situacao)" justify="center">
				<v-col cols="12" class="align-content-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="REAPROVEITAR VAGA"
							@click="exibeModalReaproveitar = true"
						/>
				</v-col>
			</v-row>
		</template>
		<v-container fluid>
			<v-card v-if="dataVaga" flat rounded class="pa-4">
				<v-row>
					<v-col cols="12">
						<b>Situação:</b> <span :class="`text-${listaSituacao.find((s) => s.value === dataVaga.situacao).textColor}`">{{ listaSituacao.find((s) => s.value === dataVaga.situacao).label }}</span>
					</v-col>
					<v-col cols="12" md="6">
						<b>Protocolo: </b>{{ dataVaga.protocolo }}
					</v-col>
					<v-col cols="12" md="6">
						<div v-if="rotaAdmin && dataVaga.usuarioAnalista && dataVaga.usuarioAnalista.nome">
							<b>Analista: </b>{{ dataVaga.usuarioAnalista.nome }}
						</div>
					</v-col>
					<v-col cols="12" md="6">
						<b>Data de abertura: </b>{{ dataVaga.dataInicio }}
					</v-col>
					<v-col cols="12" md="6">
						<b>Data da última alteração: </b>{{ dataVaga.dataAlteracao }}
					</v-col>
				</v-row>
			</v-card>
			<v-row v-if="dataVaga && rotaAdmin">
				<v-col cols="12">
					<v-expansion-panels v-model="accordeon.empregador" flat rounded multiple bg-color="backgroundCard" variant="default" class="mt-4">
						<v-expansion-panel title="Identificação do Empregador" value="open" >
							<v-expansion-panel-text>
								<IdentificacaoEmpregador
									class="my-8"
									:empregador-form="empregadorForm"
									:empregador-form-contratante="empregadorFormContratante"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									/>
							</v-expansion-panel-text>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
				<v-col cols="12">
					<v-expansion-panels v-model="accordeon.dadosVaga" flat rounded multiple bg-color="backgroundCard" variant="default">
						<v-expansion-panel title="Dados da Vaga" value="open" >
							<v-expansion-panel-text>
								<DadosVaga
									class="my-8"
									:dados-vaga-form="dadosVagaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									/>
							</v-expansion-panel-text>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
				<v-col cols="12">
					<v-expansion-panels v-model="accordeon.requisitos" flat rounded multiple bg-color="backgroundCard" variant="default">
						<v-expansion-panel title="Requisitos" value="open" >
							<v-expansion-panel-text>
								<Requisitos
									class="my-8"
									:requisitos-form="requisitosForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									/>
							</v-expansion-panel-text>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
				<v-col cols="12">
					<v-expansion-panels v-model="accordeon.dadosEntrevista" flat rounded multiple bg-color="backgroundCard" variant="default">
						<v-expansion-panel title="Dados da Entrevista" value="open" >
							<v-expansion-panel-text>
								<DadosEntrevista
									class="my-8"
									:dados-entrevista-form="dadosEntrevistaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									/>
							</v-expansion-panel-text>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-col>
			</v-row>
			<v-card v-if="dataVaga && !rotaAdmin" flat rounded class="pa-8 mt-4">
				<v-row v-if="permissaoAcao.editar.includes(dataVaga.situacao) && !isEditar && !rotaAdmin && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.CADASTRAR_VAGA)" justify="end">
					<v-col cols="12" md="2" align="end">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="EDITAR"
							@click="router.push(`/vagas/${route.params.id || 0}/editar`)"
						></v-btn>
					</v-col>
				</v-row>
				<v-row justify="center">
					<v-col cols="12">
						<v-tabs
							v-model="tab"
							:color="corTexto"
							align-tabs="center"
							>
							<v-tab
								v-for="passo in passos"
								:key="passo.value"
								:text="passo.label"
								:value="passo.value"
								:readonly="passo.disabled || isEditar"
							/>
						</v-tabs>

						<v-tabs-window v-model="tab">
							<v-tabs-window-item :value="0">
								<IdentificacaoEmpregador
									v-if="tab === 0"
									:key="tab"
									class="mt-8"
									:empregador-form="empregadorForm"
									:empregador-form-contratante="empregadorFormContratante"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									@proximo-passo="proximoPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="1">
								<DadosVaga
									v-if="tab === 1"
									:key="tab"
									class="mt-8"
									:dados-vaga-form="dadosVagaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									@proximo-passo="proximoPasso"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="2">
								<Requisitos
									v-if="tab === 2"
									:key="tab"
									class="mt-8"
									:requisitos-form="requisitosForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									@proximo-passo="proximoPasso"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
							<v-tabs-window-item :value="3">
								<DadosEntrevista
									v-if="tab === 3"
									:key="tab"
									class="mt-8"
									:dados-entrevista-form="dadosEntrevistaForm"
									:form-desabilitado="formDesabilitado"
									:data-vaga="dataVaga"
									:esconde-botoes="!isEditar"
									:modo-solicitacao="true"
									@proximo-passo="router.go()"
									@passo-anterior="voltarPasso"
									/>
							</v-tabs-window-item>
						</v-tabs-window>
					</v-col>
				</v-row>
			</v-card>
			<v-card v-if="dataVaga" flat rounded class="pa-4 mt-4">
				<v-row>
					<v-col cols="12">
						<h2>Histórico</h2>
						<hr/>
					</v-col>
					<v-col cols="12">
						<div v-if="listaHistorico.length" class="overflow-y-auto" style="max-height: 300px;">
							<v-card v-for="historico in listaHistorico" :key="historico.id" flat rounded color="filled" class="my-2">
								<v-row class="ma-2">
									<v-col cols="12" md="10">
										<span>{{ historico.dataMovimentacao }}</span> | Situação: <span :class="`text-${listaSituacao.find((s) => s.value === historico.situacao).textColor}`">{{ listaSituacao.find((s) => s.value === historico.situacao).label }}</span>
										<p style="font-weight: 400; font-size: 14px;">
											<span>{{ historico.descricaoMovimentacao }}</span>
											<br v-if="historico.descricaoMovimentacao" />
											<b v-if="historico.situacao === 'CANCELADA'">Cancelada pelo solicitante.</b>
											<b v-else>Analisado por: <span>{{ historico.usuario.nome }}</span></b>
										</p>
									</v-col>
									<v-col cols="12" md="2" align="center" style="align-content: center;">
										<p v-if="historico.anexo" style="font-weight: 400; font-size: 14px;">
											<v-btn variant="text" color="primary" @click="baixarAnexo(historico)"> Baixar anexo</v-btn>
										</p>
									</v-col>
								</v-row>
							</v-card>
						</div>
						<div v-else>
							Sem histórico disponível.
						</div>
					</v-col>
				</v-row>
			</v-card>
			<v-card v-if="(!rotaAdmin && dataVaga && permissaoAcao.enviarResposta.includes(dataVaga.situacao)) || (rotaAdmin && permissaoAcao.enviarRespostaAdmin.includes(dataVaga.situacao) && usuarioPossuiPermissao(usuarioLogado, PERMISSOES_FGTAS.ANALISAR_VAGA))" rounded flat color="background" border="md" class="pa-4 mt-4">
				<v-row>
					<v-col v-if="rotaAdmin" cols="12" md="12">
						<div class="mb-2 mr-6">Nova Situação</div>
						<v-combobox v-model="novaSituacao" :items="listaSituacaoPorVaga" item-title="label" item-value="value" />
					</v-col>
					<v-col cols="12" md="12">
						<div class="mb-2 mr-6"><span v-if="precisaDescricao" class="required">* </span>{{ rotaAdmin ? "Descrição da Nova Situação" : "Resposta à Pendência" }}</div>
						<v-textarea
							v-model="observacoes"
							persistent-hint hint="O texto desta resposta, se inserido, deve ter no mínimo 10 caracteres e no máximo 1500 caracteres"
							counter counter-value="1500"
							:rules="validarMovimentacoes.observacoes(precisaDescricao)"
							/>
					</v-col>
					<v-col cols="12" md="6">
						<div class="mr-6">Anexo</div>
						<v-file-input
							v-model="anexo"
							label="Adicionar anexo"
							density="compact"
							clearable
							hint="Tamanho máximo de arquivo: 10MB; Tipos de arquivos aceitos: .png, .jpg, .doc, .docx, .pdf;"
							persistent-hint
							persistent-clear
							show-size
							:rules="[
								(val) => (!val || val.size <= 10485760) || 'O tamanho máximo de arquivo não pode ser maior que 10MB!',
							]"
							filter-by-type=".doc, .pdf, .png, .jpg, .docx"
							@update:model-value="mountFile"
							/>
					</v-col>
				</v-row>
			</v-card>
			<v-row v-if="(dataVaga && permissaoAcao.enviarResposta.includes(dataVaga.situacao)) || (rotaAdmin && permissaoAcao.enviarRespostaAdmin.includes(dataVaga.situacao))">
				<v-col cols="12" class="mt-4" align="end">
					<v-btn color="primary" :loading="loading" :disabled="desabilitaResposta" @click="enviarMovimentacao">
						ENVIAR RESPOSTA
					</v-btn>
				</v-col>
			</v-row>
		</v-container>
		<v-dialog v-model="exibeModal" width="auto">
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Situação atualizada com sucesso!</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="exibeModal = false"
					></v-btn>
				</template>
				<div class="px-4">
					A nova situação foi registrada no sistema. Você pode acompanhar os detalhes no histórico abaixo.
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="12" md="3" />
					<v-col cols="12" md="6" class="text-center">
						<v-btn
						block
						:color="corTexto"
						variant="outlined"
						text="VOLTAR"
						@click="exibeModal = false"
						></v-btn>
					</v-col>
					<v-col cols="12" md="3" />
				</v-row>
			</v-card>
		</v-dialog>
		<v-dialog v-model="exibeModalReaproveitar" width="auto" persistent>
			<v-card
				color="background"
				class="pa-4"
				max-width="500"
				style="border-radius: 10px;"
			>
				<template v-slot:title><span :class="`text-${corTexto}`">Deseja Reaproveitar essa vaga?</span></template>
				<template v-slot:append>
					<v-btn
						class="text-none"
						:color="corTexto"
						variant="text"
						slim
						icon="mdi-close"
						@click="exibeModalReaproveitar = false"
					></v-btn>
				</template>
				<div class="px-4">
					Ao prosseguir, uma nova vaga será gerada em rascunho, reaproveitando os dados inseridos na vaga selecionada.
				</div>
				<v-row class="mt-4 mb-2 px-12">
					<v-col cols="6" class="text-center">
						<v-btn
							block
							:color="corTexto"
							variant="outlined"
							text="CANCELAR"
							@click="exibeModalReaproveitar = false"
						></v-btn>
					</v-col>
					<v-col cols="6" class="text-center">
						<v-btn
							block
							color="primary"
							text="REAPROVEITAR"
							@click="reaproveitar"
						></v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</ViewWrapper>
</template>
<script setup>
import { useRoute, useRouter } from 'vue-router'
import { ref, onMounted, watch, computed, nextTick } from 'vue';
import ViewWrapper from '@/components/commons/wrapper/ViewWrapper.vue';
import IdentificacaoEmpregador from '@/components/vagas/passos/IdentificacaoEmpregador.vue';
import DadosVaga from '@/components/vagas/passos/DadosVaga.vue';
import Requisitos from '@/components/vagas/passos/Requisitos.vue';
import DadosEntrevista from '@/components/vagas/passos/DadosEntrevista.vue';
import { buscarSituacoesPossiveis, buscarVaga, reaproveitarVaga } from '@/services/VagaService';
import { ErroAlert, SucessoAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { buscarAnexoHistorico, buscarHistorico, salvarMovimentacao } from '@/services/MovimentacaoService';
import { validarMovimentacoes } from '@/utils/ValidacoesUtils';
import { useStore } from 'vuex';
import { PERMISSOES_FGTAS, usuarioPossuiPermissao } from '@/utils/PermissaoUtils';
import { gerarPDFVaga } from '@/utils/PDFUtils';


const route = useRoute();
const router = useRouter();
const store = useStore();

const permissaoAcao = {
	editar: ["PROTOCOLADA", "PENDENTE"],
	enviarResposta: ["PENDENTE"],
	reaproveitar: ["ENCERRADA"],
	enviarRespostaAdmin: ["PENDENTE", "PROTOCOLADA", "EM_ANALISE", "RETORNO_PENDENCIA", "CADASTRADA", "INDEFERIDA", "ENCERRADA"],
};

const loading = ref(false);
const editando = ref(false);
const exibeModal = ref(false);
const formDesabilitado = ref(false);
const exibeModalReaproveitar = ref(false);
const arquivo = ref();
const observacoes = ref("");
const anexo = ref();
const dataVaga = ref();
const novaSituacao = ref();
const listaHistorico = ref([]);
const listaSituacaoPorVaga = ref([]);
const tab = ref(0);
const rotaAdmin = ref(false);
const temSituacao = ref(true);
const precisaDescricao = ref(false);

const passos = [
	{ label: "Identificação do Empregador", value: 0, disabled: false },
	{ label: "Dados da VAGA", value: 1, disabled: false },
	{ label: "Requisitos", value: 2, disabled: false },
	{ label: "Dados da Entrevista", value: 3, disabled: false },
];
const listaSituacao = [
	{ label: "RASCUNHO", value: "RASCUNHO", textColor: "situacaoRascunho" },
	{ label: "PROTOCOLADA", value: "PROTOCOLADA", textColor: "situacaoProtocolada" },
	{ label: "EM ANÁLISE", value: "EM_ANALISE", textColor: "situacaoEmAnalise" },
	{ label: "PENDENTE", value: "PENDENTE", textColor: "situacaoPendente" },
	{ label: "EM ANÁLISE (RETORNO DE PENDÊNCIA)", value: "RETORNO_PENDENCIA", textColor: "situacaoRetornoPendencia" },
	{ label: "VAGA CADASTRADA", value: "CADASTRADA", textColor: "situacaoCadastrada" },
	{ label: "INDEFERIDA", value: "INDEFERIDA", textColor: "situacaoIndeferida" },
	{ label: "CANCELADA", value: "CANCELADA", textColor: "situacaoCancelada" },
	{ label: "ENCERRADA", value: "ENCERRADA", textColor: "situacaoEncerrada" },
];
const accordeon = ref({
	empregador: [],
	dadosVaga: [],
	requisitos: [],
	dadosEntrevista: [],
});

const empregadorForm = ref({
	id: editando.value ? Number(route.params?.id) : undefined,
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
	logradouro: "",
	numero: "",
	bairro: "",
	cep: "",
	uf: "",
	cidade: "",
	tipoLogradouro: undefined,
	referenciaAcesso: "",
	telefone: "",
	utilizaWhatsApp: undefined,
	email: "",
	responsavelSINE: "",
	cargo: "",
	outroContratante: undefined,
});
const empregadorFormContratante = ref({
	tipoIdentificacao: "CNPJ",
	numeroIdentificacao: "",
	razaoSocial: "",
});
const dadosVagaForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	ocupacao: undefined,
	cbo: undefined,
	numeroVagas: undefined,
	salarioMensal: undefined,
	descricaoAtividades: undefined,
	logradouro: undefined,
	numero: undefined,
	bairro: undefined,
	cep: undefined,
	uf: undefined,
	cidade: undefined,
	tipoLogradouro: undefined,
	referenciaAcesso: undefined,
	enderecoTrabalhoIgual: undefined,
	horarioTrabalho: undefined,
	pcd: undefined,
	tipoContratacao: undefined,
	instituicao: undefined,
	nomeCurso: undefined,
	dataInicioCurso: undefined,
	cargaHorariaTeoricaSemanal: undefined,
	cargaHorariaPraticaSemanal: undefined,
	beneficios: [],
	motivosContratacao: [],
	agencia: undefined,
})
const requisitosForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	experiencia: undefined,
	comprovacaoCTPS: undefined,
	escolaridadeMinima: undefined,
	tipoHabilitacao: undefined,
	observacoes: "",
})
const dadosEntrevistaForm = ref({
	id: editando ? Number(route.params?.id) : undefined,
	responsavel: undefined,
	cargo: undefined,
	listaDataHorario: [{ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined }],
	local: undefined,
	dataRetorno: undefined,
})

const usuarioLogado = computed(() => store.getters["usuario/getUsuarioLogado"]);

const isEditar = computed(() => {
	return route.fullPath.includes("/editar");
})

const desabilitaResposta = computed(() => {
	temSituacao.value = true;
	precisaDescricao.value = false;
	const novaSituacaoValido = ref(false);
	const descricaoAtividadesValido = ref(false);
	const anexoValido = ref(false);

	if (rotaAdmin.value) {
		temSituacao.value = !!novaSituacao.value;
		if (novaSituacao.value && ["INDEFERIDA", "PENDENTE"].includes(novaSituacao.value.value)) {
			precisaDescricao.value = true;
		}
	} else {
		precisaDescricao.value = true;
	}

	anexoValido.value = (anexo.value && anexo.value.size > 10485760) ? false : true;
	novaSituacaoValido.value = rotaAdmin.value ? !!novaSituacao.value : true;
	if (precisaDescricao.value) {
		if (!observacoes.value) {
			descricaoAtividadesValido.value = false;
		}
		else if (observacoes.value && (observacoes.value.length >= 10 && observacoes.value.length <= 1500)) {
			descricaoAtividadesValido.value = true;
		}
	} else if(!observacoes.value || (observacoes.value.length >= 10 && observacoes.value.length <= 1500)) {
		descricaoAtividadesValido.value = true;
	}

	return !(novaSituacaoValido.value && descricaoAtividadesValido.value && anexoValido.value);
})

function preenchePassos(vaga) {
	empregadorForm.value = {
		id: vaga.id || undefined,
		tipoIdentificacao: vaga.empregador.tipoIdentificacao || undefined,
		numeroIdentificacao: vaga.empregador.numeroIdentificacao || undefined,
		razaoSocial: vaga.empregador.razaoSocial || undefined,
		logradouro: vaga.empregador.endereco.logradouro || undefined,
		numero: vaga.empregador.endereco.numero || undefined,
		bairro: vaga.empregador.endereco.bairro || undefined,
		cep: vaga.empregador.endereco.cep || undefined,
		uf: vaga.empregador.endereco.municipio ? vaga.empregador.endereco.municipio.uf : undefined,
		cidade: vaga.empregador.endereco.municipio ? vaga.empregador.endereco.municipio : undefined,
		tipoLogradouro: vaga.empregador.endereco.tipoLogradouro || undefined,
		referenciaAcesso: vaga.empregador.endereco.referenciaAcesso || undefined,
		telefone: vaga.empregador.contato.telefone || undefined,
		utilizaWhatsApp: vaga.empregador.contato.utilizaWhatsApp || undefined,
		email: vaga.empregador.contato.email || undefined,
		responsavelSINE: vaga.empregador.contato.responsavelSINE || undefined,
		cargo: vaga.empregador.cargo || undefined,
		outroContratante: vaga.outroContratante || undefined,
	}
	if (vaga.outroContratante === "S") {
		empregadorFormContratante.value = {
			tipoIdentificacao: vaga.contratante.tipoIdentificacao || undefined,
			numeroIdentificacao: vaga.contratante.numeroIdentificacao || undefined,
			razaoSocial: vaga.contratante.razaoSocial || undefined,
		}
	}
	const mappedBeneficios = vaga.beneficios
		? vaga.beneficios.map((beneficio) => {
			return {
				...beneficio.tipoBeneficio,
				complemento: beneficio.complemento,
				idBeneficio: beneficio.id,
			}
		})
		: []
	const mappedMotivoContratacao = vaga.motivosContratacao
		? vaga.motivosContratacao.map((motivo) => {
			return {
				...motivo.motivoContratacao,
				idMotivo: motivo.id,
			}
		})
		: []
	dadosVagaForm.value = {
		id: vaga.id || undefined,
		ocupacao: vaga.ocupacao || undefined,
		cbo: vaga.cbo || undefined,
		numeroVagas: vaga.numeroVagas || undefined,
		salarioMensal: vaga.salarioMensal || undefined,
		descricaoAtividades: vaga.descricaoAtividades || undefined,
		enderecoTrabalhoIgual: vaga.enderecoTrabalhoIgual || undefined,
		logradouro: vaga.enderecoLocalTrabalho.logradouro || undefined,
		numero: vaga.enderecoLocalTrabalho.numero || undefined,
		bairro: vaga.enderecoLocalTrabalho.bairro || undefined,
		cep: vaga.enderecoLocalTrabalho.cep || undefined,
		uf: vaga.enderecoLocalTrabalho.municipio ? vaga.enderecoLocalTrabalho.municipio.uf : undefined,
		cidade: vaga.enderecoLocalTrabalho.municipio ? vaga.enderecoLocalTrabalho.municipio : undefined,
		tipoLogradouro: vaga.enderecoLocalTrabalho.tipoLogradouro || undefined,
		referenciaAcesso: vaga.enderecoLocalTrabalho.referenciaAcesso || undefined,
		horarioTrabalho: vaga.horarioTrabalho || undefined,
		pcd: vaga.pcd || undefined,
		tipoContratacao: vaga.tipoContratacao || undefined,
		instituicao: vaga.curso.instituicao || undefined,
		nomeCurso: vaga.curso.nomeCurso || undefined,
		dataInicioCurso: vaga.curso.dataInicioCurso || undefined,
		cargaHorariaTeoricaSemanal: vaga.curso.cargaHorariaTeoricaSemanal || undefined,
		cargaHorariaPraticaSemanal: vaga.curso.cargaHorariaPraticaSemanal || undefined,
		tipoContratacao: vaga.tipoContratacao || undefined,
		periodoContratacao: vaga.periodoContratacao || undefined,
		beneficios: mappedBeneficios,
		motivosContratacao: mappedMotivoContratacao,
		agencia: vaga.agencia.id ? vaga.agencia : undefined,
	}
	requisitosForm.value = {
		id: vaga.id || undefined,
		experiencia: vaga.requisitos.experiencia || undefined,
		comprovacaoCTPS: vaga.requisitos.comprovacaoCTPS || undefined,
		escolaridadeMinima: vaga.requisitos.escolaridadeMinima && vaga.requisitos.escolaridadeMinima.id ? vaga.requisitos.escolaridadeMinima : undefined,
		tipoHabilitacao: vaga.requisitos.tipoHabilitacao && vaga.requisitos.tipoHabilitacao.id ? vaga.requisitos.tipoHabilitacao : undefined,
		observacoes: vaga.requisitos.observacoes || undefined,
	}
	const mappedListaDataHorario = vaga.dadosEntrevista.listaDataHorario
	? vaga.dadosEntrevista.listaDataHorario.map((data) => {
			const [dia, mes, ano] = data.dataEntrevista.split("/");
			return {
				id: data.id,
				dataEntrevista: data.dataEntrevista,
				horarioEntrevista: data.horarioEntrevista,
				unformattedData: new Date(ano, mes - 1, dia),
			}
	})
	: [{ id: undefined, dataEntrevista: undefined, horarioEntrevista: undefined, unformattedData: undefined }]
	dadosEntrevistaForm.value = {
		id: vaga.id || undefined,
		responsavel: vaga.dadosEntrevista.responsavel || undefined,
		cargo: vaga.dadosEntrevista.cargo || undefined,
		local: vaga.dadosEntrevista.local || undefined,
		listaDataHorario: mappedListaDataHorario,
		dataRetorno: vaga.dadosEntrevista.dataRetorno || undefined,
	}
}

async function reaproveitar() {
	loading.value = true;
	await reaproveitarVaga(dataVaga.value.id)
		.then(async ({ data }) => {
			SucessoAlert({ mensagem: "Vaga reaproveitada com sucesso!" });
			router.push(`/vagas/${data.id || 0}`);
			exibeModalReaproveitar.value = false;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível reaproveitar a vaga no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

async function mountFile() {
	if (!anexo.value) {
		return;
	}
	const reader = new FileReader();
	reader.readAsDataURL(anexo.value);
	reader.onloadend = (event) => {
		arquivo.value = { nome: anexo.value.name, mimeType: anexo.value.type, dataUri: event.target.result };
	}
}

async function buscarDadosVaga() {
	loading.value = true;
	await buscarVaga(route.params?.id || 0)
		.then(async ({ data }) => {
			dataVaga.value = data;
			if (dataVaga.value.dataFim) {
				router.push("/vagas/lista");
				return;
			}
			if (dataVaga.value.situacao === "RASCUNHO") {
				router.push("/vagas/lista");
				return;
			}
			formDesabilitado.value = !isEditar.value;
			preenchePassos(dataVaga.value);
			await buscarHistoricoVagas();
		})
		.catch((error) => {
			router.push("/vagas/lista");
			ErroAlert({ mensagem: "Não foi possível encontrar vaga.", error });
		})
		.finally(() => loading.value = false);
}

async function enviarMovimentacao() {
	loading.value = true;
	await salvarMovimentacao({
			vaga: { id: dataVaga.value.id || 0 },
			descricaoMovimentacao: observacoes.value,
			situacao: rotaAdmin.value ? novaSituacao.value.value : "RETORNO_PENDENCIA",
			anexo: arquivo.value || undefined,
		})
		.then(async ({ data }) => {
			await buscarDadosVaga();
			observacoes.value = undefined;
			anexo.value = undefined;
			novaSituacao.value = undefined;
			exibeModal.value = true;
		})
		.catch((error) => {
			ErroAlert({ mensagem: error.response.data.mensagem, error });
		})
		.finally(() => loading.value = false);
}

async function baixarAnexo(historico) {
	loading.value = true;
	await buscarAnexoHistorico(historico.id)
		.then(async ({ data }) => {
			const base64 = data;
			const mimeType = historico.anexo.mimeType ? historico.anexo.mimeType : "application/pdf";
			const link = `data:a${mimeType};base64,${base64}`;
			const download = document.createElement("a");
			download.href = link;
			download.download = historico.anexo.nome;
			download.click();
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível baixar o anexo no momento. Tente novamente mais tarde", error });
		})
		.finally(() => loading.value = false);
}

async function buscarHistoricoVagas() {
	loading.value = true;
	await buscarHistorico(dataVaga.value.id || 0)
		.then(({ data }) => {
			listaHistorico.value = data;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível encontrar histórico.", error });
		})
		.finally(() => loading.value = false);
}

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
})

async function gerarPDF() {
	gerarPDFVaga(dataVaga.value, usuarioLogado.value.nome);
}

async function proximoPasso() {
	if (tab.value === 3) {
		return;
	}
	if (!formDesabilitado.value) {
		loading.value = true;
		await buscarVaga(route.params?.id || 0)
			.then(({ data }) => {
				dataVaga.value = data;
				preenchePassos(dataVaga.value);
			})
			.catch((error) => {
				console.error(error.response.data.mensagem);
			})
			.finally(() => loading.value = false);
	}
	tab.value = tab.value + 1;
};

async function buscarListaSituacao() {
	await buscarSituacoesPossiveis(dataVaga.value.id, { usuarioSolicitante: !rotaAdmin.value })
		.then(({ data }) => {
			listaSituacaoPorVaga.value = data.map((situacao) => listaSituacao.find((s) => s.value === situacao));
		})
		.catch((error) => {
			console.error(error.response.data.mensagem)
		});
}

function voltarPasso() {
	tab.value = tab.value - 1;
};

watch(tab, () => {
	if (dataVaga.value) {
		preenchePassos(dataVaga.value);
	}
}, { immediate: true });

watch(accordeon, () => {
	if (dataVaga.value) {
		preenchePassos(dataVaga.value);
	}
}, { immediate: true, deep: true });

onMounted(async () => {
	const permissao = ref();
	if (route.fullPath.includes("/admin")) {
		permissao.value = PERMISSOES_FGTAS.VISUALIZAR_SOLICITACAO_VAGA;
	}
	else if (route.fullPath.includes("/editar")) {
		permissao.value = PERMISSOES_FGTAS.CADASTRAR_VAGA;
	}
	else if (route.fullPath.includes("/visualizar")) {
		permissao.value = PERMISSOES_FGTAS.ACOMPANHAR_VAGA;
	}
	const temPermissao = usuarioPossuiPermissao(usuarioLogado.value, permissao.value);
	if (!temPermissao) {
		console.warn("Você não possui permissão para acessar esta tela!");
		router.push("/");
	}
	if (!isNaN(route.params?.id)) {
		editando.value = true;
		await buscarDadosVaga();
	}
	if (route.fullPath.includes("/admin")) {
		rotaAdmin.value = true;
	}
	await buscarListaSituacao();
});
</script>
<style lang="css" scoped>
.radio {
	display: inline-flex;
}
.required {
	color: red;
}
</style>